// extracted by mini-css-extract-plugin
export default {"extraChargeTypeManagement":"ExtraChargeTypeManagement_extraChargeTypeManagement__FEdiO","container":"ExtraChargeTypeManagement_container__kzrhz"};